module.exports = __webpack_public_path__ + "static/media/jewerlyandaccesories.1d8f2589.jpg";